/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useResetTreeSelect } from "@/global-data/use-reset-tree-select";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { useToast } from "@/hooks/use-toast";
import { getFileUrl } from "@/lib/get-file-url";
import { objectMutation } from "@/lib/object-mutation";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import {
  synonym,
  documentsUpload,
  companies,
} from "@/services/global.services";
import { useEffect, useMemo, useState } from "react";

export const useMutations = () => {
  const API_SERVICE = synonym;
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id /*  */,
      user_id: tempUserData?.user_id || "",
    };
  }, []);
  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const { toast } = useToast();

  const [listData, setListData] = useState([]);

  const [erpListData] = useState<Array<Record<string, string>>>([]);
  const [formType, setFormType] = useState<any>(undefined);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [activeRecordData, setActiveRecordData] = useState<any>(undefined);
  const [open, onOpenChange] = useState(false);
  const [updateList, setUpdateList] = useState<string[]>([]);

  const { setSearchProgress, search } = useGlobalSearch();
  const [searchDebounced] = useDebouncedValue(search, 200);

  const { status, identity, id, clearDelete } = useDeletePopup();
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  const [companyData, setCompanyData] = useState<any>(undefined);

  //On Load Component
  useEffect(() => {
    (async () => {
      // await loadingList();
      // await loadingErp();
      // await loadingCompany();
      await Promise.all([loadingList(), loadingErp(), loadingCompany()]);
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
  }, []);

  const [order_type] = useState([
    {
      label: "Sales Order",
      value: "sales_order",
    },
    {
      label: "Purchase Order",
      value: "purchase_order",
    },
  ]);

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      alert(JSON.stringify(id));
      clearDelete();
    }
  }, [status]);

  // const deleteSynonym = async () => {};

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        /* const response =  */ await loadingList();
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
    }
  }, [formPopupOpen]);

  const loadingCompany = async () => {
    // const userData: any = getUserInfo();
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      companies.get,
      "post",
      payload
    );

    if (data) {
      setCompanyData(data.result.metadata[companies.key][0]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const loadingList = async () => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
          pagination: {
            sort_by: "cts",
            order_by: false,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.get,
      "post",
      payload
    );

    if (data) {
      setListData(data.result.metadata[API_SERVICE.key]);
      setUpdateList([]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  // function getErpKeys(obj: any, prefix: any = "") {
  //   let result: Array<Record<string, string>> = [];
  //   for (const key in obj) {
  //     const fullKey = prefix ? `${prefix}.${key}` : key;
  //     result.push({ label: fullKey, value: fullKey });

  //     if (
  //       typeof obj[key] === "object" &&
  //       obj[key] !== null &&
  //       !Array.isArray(obj[key])
  //     ) {
  //       result = result.concat(getErpKeys(obj[key], fullKey));
  //     }
  //   }
  //   return result;
  // }

  const loadingErp = async () => {
    // const payload = {
    //   data: {
    //     filter_by: {
    //       search_text: "",
    //       exact_match: false,
    //     },
    //   },
    //   company_id: company_id,
    //   user_id: user_id,
    // };
    // const { data, error, message } = await apiServices<any>(
    //   erp.get,
    //   "post",
    //   payload
    // );
    // if (data) {
    //   const get_all_key = getErpKeys(data.result.metadata[erp.key]);
    //   setErpListData(get_all_key);
    // }
    // if (error) {
    //   toast({
    //     title: "Error",
    //     variant: "destructive",
    //     description: error.status?.message || message,
    //   });
    // }
    // return { data, error };
  };

  const onFormSubmit = async (prop: any): Promise<any> => {
    const payload = {
      data: {
        synonym_objects: [
          {
            domain_name: prop.domain_name,
            type: "domain",
            order_type: prop.order_type,
            is_new: true,
            // entities: [],
          },
        ],
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload
    );

    if (data) {
      const response = await loadingList();

      if (response?.data) {
        toast({
          title: "Success",
          description: data.result.metadata.message,
          variant: "success",
        });
      }
    }

    if (error) {
      setProcess(false);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const onUpdate = async (prop: any): Promise<any> => {
    setProcess(true);
    const payload = {
      data: prop,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload
    );

    if (data) {
      const response = await loadingList();
      if (response?.data) {
        toast({
          title: "Success",
          variant: "success",
          description: data.result.metadata.message,
        });
      }
    }

    if (error) {
      setProcess(false);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
    return { data, error };
  };

  const onListChange = (prop: any) => {
    setListData(prop);
  };

  const { dragParentId, setDragParentId } = useResetTreeSelect();

  const sortingTree = ({ newArray, parentKey }: any) => {
    console.log({ newArray, parentKey, dragParentId });
    if (parentKey?.[0] && !updateList.includes(parentKey?.[0])) {
      setUpdateList((prev) => [...prev, parentKey?.[0]]);
    }
    setIsSaveEnabled(true);
    const newKey = parentKey + ".attributes";

    const updatedObj = objectMutation.update(listData, newKey, newArray);
    if (parentKey === dragParentId) {
      setDragParentId(undefined);
      setListData(updatedObj);
    }
  };

  const onTreeMutation = async (prop: any) => {
    if (prop?.key?.[0] && !updateList.includes(prop?.key?.[0])) {
      setUpdateList((prev) => [...prev, prop?.key?.[0]]);
    }

    if (prop.actionType === "add") {
      if (prop.type === "domain") {
        setFormType("entity");
        setActiveRecordData(prop);
        addNewTreeItem(prop, "entity");
      }
      if (prop.type === "entity") {
        setFormType("attribute");
        addNewTreeItem(prop, "attribute");
      }
    } else if (prop.actionType === "save") {
      setIsSaveEnabled(false);
      // const currentData: any = listData[0];
      const payload: any = [];
      console.log({ listData, updateList });

      listData.forEach((item: any, index: number) => {
        const tempItem = {
          domain_id: item.domain_id,
          domain_name: item.domain_name,
          entities: item.entities,
          order_type: item.order_type,
          // is_new: true,
        };
        if (updateList.includes("" + index)) {
          payload.push(tempItem);
        }
      });

      onUpdate({ synonym_objects: payload });
    } else if (prop.actionType === "edit") {
      setFormType(prop.type);
      setActiveRecordData(prop);
    } else if (prop.actionType === "delete") {
      const newKey = prop.key.replace(".synonyms", "");
      const updatedObj = objectMutation.delete(listData, newKey);
      setListData(updatedObj);
    }
  };

  const addNewTreeItem = (currentRecord: any, type: string) => {
    if (currentRecord?.actionType === "add") {
      if (type === "entity") {
        const newKey = `${currentRecord.key}.entities`;
        console.log({ newKey });
        const oldList = objectMutation.get(listData, newKey);
        const formData = {
          name: "untitled_" + oldList.length,
          type: "entity",
          attributes: [],
        };
        oldList.push(formData);
        const updatedData = objectMutation.update(listData, newKey, oldList);
        setListData(updatedData);
      }
      if (type === "attribute") {
        const newKey = `${currentRecord.key}.attributes`;
        const oldList = objectMutation.get(listData, newKey);
        const formData = {
          name: "untitled_" + oldList.length,
          type: "attribute",
          synonyms: [],
          cardinality: "1",
          erp_mapping: "untitled_" + oldList.length,
        };
        oldList.push(formData);
        const updatedData = objectMutation.update(listData, newKey, oldList);
        setListData(updatedData);
      }
    }
  };

  const onTreeFormSubmit = (prop: any) => {
    if (activeRecordData?.actionType === "add") {
      if (formType === "entity") {
        const newKey = `${activeRecordData.key}.entities`;
        const oldList = objectMutation.get(listData, newKey);
        const formData = {
          name: prop.name,
          type: "entity",
          attributes: [],
        };
        oldList.push(formData);
        const updatedData = objectMutation.update(listData, newKey, oldList);
        setListData(updatedData);
      }
      if (formType === "attribute") {
        const newKey = `${activeRecordData.key}.attributes`;
        const oldList = objectMutation.get(listData, newKey);
        const formData = {
          name: prop.name,
          type: "attribute",
          synonyms: [],
          erp_mapping: prop.name,
        };
        oldList.push(formData);
        const updatedData = objectMutation.update(listData, newKey, oldList);
        setListData(updatedData);
      }
    }
    if (activeRecordData?.actionType === "edit") {
      if (formType === "domain") {
        const newKey = activeRecordData.key + ".domain_name";
        const updatedData = objectMutation.update(listData, newKey, prop.name);
        setListData(updatedData);
      }

      if (formType === "entity") {
        const newKey = activeRecordData.key + ".name";
        const updatedData = objectMutation.update(listData, newKey, prop.name);
        setListData(updatedData);
      }

      if (formType === "attribute") {
        const newKey = activeRecordData.key.replace(".synonyms", "");
        const nameKey = newKey + ".name";
        const erpMappingKey = newKey + ".erp_mapping";
        let updatedData = objectMutation.update(listData, nameKey, prop.name);
        updatedData = objectMutation.update(
          updatedData,
          erpMappingKey,
          prop.name
        );
        setListData(updatedData);
      }
    }

    setActiveRecordData(undefined);
    setFormType(undefined);
  };

  const onRunDocument = async (prop: any): Promise<any> => {
    setProcess(true);

    const payload = {
      data: { file_path: prop },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message /* statusCode */ } = await apiServices<any>(
      API_SERVICE.import,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const onTreeFormEdit = (prop: any, prop2?: any) => {
    if (prop2?.key?.[0] && !updateList.includes(prop2?.key?.[0])) {
      setUpdateList((prev) => [...prev, prop2?.key?.[0]]);
    }
    // updateList, setUpdateList;
    if (prop2?.type === "domain") {
      const newKey = prop2.key + ".domain_name";
      const typeKey = prop2.key + ".type";
      const orderTypeKey = prop2.key + ".order_type";

      let updatedData = objectMutation.update(listData, newKey, prop.name);
      updatedData = objectMutation.update(updatedData, typeKey, prop.name);
      updatedData = objectMutation.update(
        updatedData,
        orderTypeKey,
        prop.order_type
      );
      setListData(updatedData);
    }

    if (prop2?.type === "entity") {
      const newKey = prop2.key + ".name";
      const cardinalityKey = prop2.key + ".cardinality";
      let updatedData = objectMutation.update(listData, newKey, prop.name);
      updatedData = objectMutation.update(
        updatedData,
        cardinalityKey,
        prop.cardinality
      );
      setListData(updatedData);
    }

    if (prop2?.type === "attribute") {
      const newKey = prop2.key.replace(".synonyms", "");
      const nameKey = newKey + ".name";
      const erpMappingKey = newKey + ".erp_mapping";

      let updatedData = objectMutation.update(listData, nameKey, prop.name);
      updatedData = objectMutation.update(
        updatedData,
        erpMappingKey,
        prop.erp_mapping
      );
      setListData(updatedData);
    }

    setActiveRecordData(undefined);
    setFormType(undefined);
  };

  const manageUpdateData = (prop: any) => {
    if (prop && !updateList.includes(prop)) {
      setUpdateList((prev) => [...prev, prop]);
    }
  };

  const importDocument = async (prop: any) => {
    if (!prop) return;
    setProcess(true);
    const payload = new FormData();

    payload.append("files", prop);

    const { data, error, message /* statusCode */ } = await apiServices<any>(
      documentsUpload.post + "/" + company_id,
      "post",
      payload
    );

    if (data) {
      const runDocument = await onRunDocument(data.metadata.file_path);

      await loadingList();
      toast({
        title: "Success",
        variant: "success",
        description: runDocument?.data?.result?.metadata?.message,
      });
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  function downloadImage(url: string) {
    // Create an anchor element
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "downloaded-document";

    // Append the anchor to the document body
    document.body.appendChild(anchor);

    // Programmatically click the anchor to trigger the download
    anchor.click();

    // Remove the anchor from the document
    document.body.removeChild(anchor);
  }

  const exportDocument = async () => {
    setProcess(true);
    const payload = {
      data: {},
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(API_SERVICE.export, "post", payload);

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    if (data) {
      const listData = data.result.metadata.export_path;
      const url = await getFileUrl(listData);

      downloadImage(url);
    }
    setProcess(false);
  };

  return {
    listData,
    onFormSubmit,
    onFormOpenChange,
    skeltonLoading,
    open,
    onOpenChange,
    onListChange,
    onTreeMutation,
    formType,
    setFormType,
    onTreeFormSubmit,
    activeRecordData,
    onTreeFormEdit,
    erpListData,
    updateList,
    manageUpdateData,
    importDocument,
    exportDocument,
    order_type,
    sortingTree,
    isSaveEnabled,
    companyData,
  };
};
